<template>
  <div>
    <v-data-table
      :headers="headers"
      :options.sync="options"
      :items="items"
      :loading="isLoading && !!items.length"
      item-key="entity_id"
      class="light-table"
      hide-default-footer
    >
      <template v-slot:body="{ items }">
        <tbody v-if="items.length">
          <tr v-for="item in items" :key="item.entity_id">
            <td>{{ item.collector_name || '-' }}</td>
            <td>{{ item.type_of_scan === 'my network' ? formatDrive(item) : cloudName(item) }}</td>
            <td>{{ item.total_files? format(item.total_files) : '-'}}</td>
            <td>{{ item.last_run ? formatDate(item.last_run) : '-' }}</td>
            <td>{{ item.scan_time ? nextRun(item) : '-' }}</td>
            <td>
              <div class="inline-tooltip">
                <transition name="fade">
                  <span v-if="!validSchedule && editorId === item.entity_id" class="tooltip-ex">
                    {{errorMessage}}
                  </span>
                </transition>
                <!-- contenteditable is delete, needs to be added and connect with API-->
                <span
                  class="editable-schedule0"
                  @keydown="detectEnter"
                  @keyup="checkScheduleValidation($event, item)"
                  @blur="saveSchedule($event, item)"
                >
                  {{ item.scan_time }}
                </span>
              </div>
            </td>
            <td>{{ item.scan_command_type ? capitalize(item.scan_command_type == "deep" ? 'risk' :  item.scan_command_type) : '-' }}</td>
            <td>
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                    text
                    icon
                    class="white-bg"
                    dark
                    v-on="on"
                  >
                    <v-icon color="#2E2B3F">more_horiz</v-icon>
                  </v-btn>
                </template>
                <v-list class="api-key-edit">
                  <v-list-item @click.stop="handleEdit(item)">
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click.stop="handleDelete(item.entity_id)">
                    <v-list-item-title color="red">Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <div v-if="isLoading && !items.length" class="text-center py-10">
      <v-progress-circular
        :size="70"
        color="primary"
        indeterminate
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { numberWithCommas } from '@/utils/main_helper'
import collectorMixin from '@/mixins/collectorMixin'
import { MY_OFFICE365_TYPES, MY_GOOGLE_WORKSPACE_TYPES, MY_AWS_WORKSPACE_TYPES } from '@/components/Scheduling/data'

export default {
  name: 'SchedulingList',
  props: {
    items: {
      type: Array,
      default: null
    }
  },
  mixins: [collectorMixin],
  computed: {
    ...mapGetters(['currentOrganization']),
    ...mapState({
      isLoading: state => state.schedulingServices.isLoadingScans
    }),
    headers () {
      const headers = [
        { text: 'Collector', value: 'collector', show: true },
        { text: 'Path', value: 'path', show: true },
        { text: 'Files', value: 'total_files', show: true },
        { text: 'Last Run', value: 'last_run', show: true },
        { text: 'Next Run', value: 'scan_time', show: true },
        { text: 'Schedule', value: 'schedule', show: true },
        { text: 'Profile Type', value: 'scan_command_type', show: true },
        { text: '', value: '', show: true, sortable: false }
      ]
      return headers.filter(i => i.show)
    }
  },
  data () {
    return {
      editorId: '',
      validSchedule: true,
      errorMessage: '',
      options: {
        page: 1,
        itemsPerPage: 15
      }
    }
  },
  methods: {
    async getScans (organizationId) {
      await this.$store.dispatch('schedulingServices/getScans', organizationId)
    },
    formatDate (value) {
      return value ? this.$moment(new Date(value)).format('YYYY-MM-DD hh : mm A') : ''
    },
    nextRun (item) {
      const date = new Date()
      let m = this.$moment(date.toLocaleDateString() + ' ' + this.checkTime(item.scan_time), 'MM/DD/YYYY hh:mm A')
      if (m.valueOf() < date.getTime()) {
        m = m.add(1, 'days')
        return m.format('YYYY-MM-DD hh : mm A')
      } else { return m.format('YYYY-MM-DD hh : mm A') }
    },
    checkTime (time) {
      const time2 = time.split(' ')[0]
      const am = time.split(' ')[1]
      const hour = time2.split(':')[0] ? time2.split(':')[0] : '00'
      const minute = time2.split(':')[1] ? time2.split(':')[1] : '00'
      return hour + ':' + minute + ' ' + am
    },
    detectEnter (evt) {
      if (evt.keyCode === 13) {
        evt.preventDefault()
        evt.target.blur()
      }
    },
    checkScheduleValidation (evt, { entityId }) {
      this.editorId = entityId
      const { innerText } = evt.target
      const types = ['am', 'pm']
      try {
        let periodTime = ''
        if (innerText.indexOf(' ') > -1) {
          periodTime = innerText.toLowerCase().split(' ')[1]
        } else {
          if (!innerText.toLowerCase().split(/(\d+)/)[1]) {
            throw Error('Please input for example like this 3 AM')
          }
          periodTime = innerText.toLowerCase().split(/(\d+)/)[1].slice(-1)[0]
        }
        const typeIndex = types.findIndex(e => {
          return e.indexOf(periodTime) > -1
        })
        if (typeIndex > -1) {
          const findNumber = innerText.toLowerCase().split(types[typeIndex])[0].trim()
          this.validSchedule = /^\d+(\.\d{1,2})?$/.test(findNumber)
          if (!this.validSchedule) throw Error('Please input for example like this 3 AM')
          if (+findNumber > 12) {
            throw Error('The hour value is max 12')
          }
        } else {
          throw Error('Please input for example like this 3 AM')
        }
        this.errorMessage = ''
      } catch (e) {
        this.validSchedule = false
        this.errorMessage = e.message
      }
    },
    saveSchedule (evt, item) {
      const { target } = evt
      if (this.errorMessage) {
        target.innerText = item.schedule.time + ' ' + item.schedule.timePeriod
      }
      this.validSchedule = true
      this.editorId = ''
      this.errorMessage = ''
    },
    formatMonthDay (day) {
      if (!Number.isInteger(day)) return day
      const length = String(day).length
      const lastNumber = length > 1 ? String(day).substring(length, length - 1) : String(day)
      switch (lastNumber) {
        case '1':
          return day + 'st'
        case '2':
          return day + 'nd'
        case '3':
          return day + 'rd'
        default:
          return day + 'th'
      }
    },
    handleEdit (item) {
      this.$emit('onEdit', item)
    },
    handleDelete (id) {
      this.$emit('onDelete', id)
    },
    formatDrive (item) {
      if (item.drives) {
        const drivesName = this.getDrivesName(item.collector_id)
        if (Array.isArray(item.drives)) {
          const drives = item.drives.map(drive => drivesName[drive] || drive)
          return drives.join(',')
        } else {
          const drives = item.drives.split(',').map(drive => drivesName[drive] || drive)
          return drives.join(', ')
        }
      } else {
        return '-'
      }
    },
    capitalize (type) {
      return type.charAt(0).toUpperCase() + type.slice(1)
    },
    format (num) {
      return numberWithCommas(num)
    },
    cloudName (item) {
      let res = []
      if (item.type_of_scan == 'office_365') {
        res = MY_OFFICE365_TYPES.filter(type => type.value === item.scan_area)
      } else if (item.type_of_scan == 'google_workspace') {
        res = MY_GOOGLE_WORKSPACE_TYPES.filter(type => type.value === item.scan_area)
      } else if (item.type_of_scan == 'aws') {
        res = MY_AWS_WORKSPACE_TYPES.filter(type => type.value === item.scan_area)
      }
      return res.length ? res[0].text : '-'
    }
  },
  watch: {
    'currentOrganization.entity_id' (entityId) {
      this.getScans(entityId)
    }
  }
}
</script>

<style scoped>
  ::v-deep .theme--light.v-icon {
    color: rgba(0,0,0,.54);
  }
  .inline-tooltip {
    position: relative;
    display: inline;
  }
  .inline-tooltip .tooltip-ex {
    position: absolute;
    left: 50%;
    top: -32px;
    margin: auto;
    width: max-content;
    transform: translateX(-50%);
    font-size: 11px;
    background: #ec6363;
    padding: 3px 7px;
    border-radius: 5px;
    color: #fff;
  }
  .inline-tooltip .tooltip-ex:after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #ec6363;
    left: 0;
    right: 0;
    margin: auto;
    bottom: -4px;
  }
  .editable-schedule {
    padding: 4px;
    transition: .4s;
    text-transform: uppercase;
  }
  .editable-schedule:hover {
    box-shadow: 0px 0px 1px 1px #ccc;
    border-radius: 3px;
  }
</style>
